// global
import { globalAggregationModels } from '../global';

export const numberAggregationModels = [...globalAggregationModels, 'sum', 'avg', 'min', 'max'];
